import type { HelpFile } from '../../types/help'
import { CreateInboundConnectorDialogTestIds } from '../../../testids/CreateInboundConnectorDialogTestIds'

export const createInboundConnectorDialogHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [CreateInboundConnectorDialogTestIds.inboundConnectorTypeSelect]: 'Art des eingehenden Konnektors — SCIM, LDAP oder Skript.',
    [CreateInboundConnectorDialogTestIds.inboundCronError]: null,
    [CreateInboundConnectorDialogTestIds.inboundCronInput]: 'Cron-Ausdruck, der steuert, wie oft dieser Konnektor ausgeführt wird.',
    [CreateInboundConnectorDialogTestIds.inboundCronPreview]: 'Lesbare Vorschau des nächsten Auslösezeitpunkts des Cron-Ausdrucks.',
    [CreateInboundConnectorDialogTestIds.inboundDisplayNameError]: null,
    [CreateInboundConnectorDialogTestIds.inboundDisplayNameInput]: null,
    [CreateInboundConnectorDialogTestIds.inboundEnabledSwitch]: 'Deaktivierte Konnektoren werden nicht geplant und laufen nicht.',
    [CreateInboundConnectorDialogTestIds.inboundTargetSystemCombobox]: 'Zielsystem, aus dem dieser Konnektor Daten abruft.',
    [CreateInboundConnectorDialogTestIds.inboundTargetSystemError]: null,
  },
}
